// @ts-nocheck
import { useState, useRef } from 'react';
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input"
import { Label } from "@/components/ui/label"

import { usePlacePatch } from '@/services/usePlacePatch';
import { useUpload } from '@/services/useUpload';
import { useOfferList } from '@/services/useOfferList';
import { Select } from '../ui/select';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faClock, faImage, faMapPin, faPaperPlane, faPencil, faPhone } from '@fortawesome/free-solid-svg-icons';

const countries: Record<string, string> = {
  FR: 'France',
  MA: 'Maroc',
  CH: 'Suisse',
  MC: 'Monaco',
  MG: 'Madagascar',
  BE: 'Belgique',
  LU: 'Luxembourg',
  ES: 'Espagne',
};

export default function PlaceDetail({place}) {
  const { mutate } = usePlacePatch({velId: place.r2vel, placeId: place.msdsId});
  const upload = useUpload();
  const [edit, editSet] = useState(false);
  const fileInputRef = useRef<HTMLInputElement>(null);

  const [state, stateSet] = useState({
    name: place.name,
    address: place.address,
    address2: place.address2,
    zip: place.zip,
    city: place.city,
    country: place.country,
    phone: place.phone,
    opening_hours: place.opening_hours,
    notifyMail: place.notifyMail,
    imgUrl: place.imgUrl
  });

  const onChange = e => {
    stateSet({...state, [e.target.name]: e.target.value });
  };

  const goEdit = e => {
    e.preventDefault();
    editSet(true);
  };

  const save = e => {
    e.preventDefault();
    mutate(state);
    editSet(false);
  }

  const onFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const files = event.target.files;

    if (files && files.length > 0) {
      const key = `prod/r2vel/${place.r2vel}/places/${place.msdsId}/${Date.now()}-${files[0].name}`
      upload.mutate({file:files[0], key}, {
        onSuccess: (url) => {
          mutate({ imgUrl: url });
          stateSet({...state, imgUrl: url});
        }
      });
    }
  };

  if (!edit ) {
    return (
      <>
        <div className='flex gap-10 w-full' style={{justifyContent:'space-between', alignItems:'center', borderBottom:'1px solid #eee', paddingBottom:'10px', marginBottom:'10px'}}>
          <div>
            {state.imgUrl && <img width="200" height="auto" src={state.imgUrl} alt='logo' />}
            {!state.imgUrl && <div style={{width:'200px'}}>Pas d'image</div>}
          </div>
          <div>
            <div className='flex gap-1' style={{alignItems:'center'}}>
              <h1 className="font-bold text-2xl">{state.name}</h1>
            </div>
            <div>
              <p className="font-bold">
                <FontAwesomeIcon icon={faMapPin} className='mr-2'/>
                {state.address}
              </p>
              <p className="font-bold">
                {state.address2}
              </p>
              <p className="font-bold">
                {state.zip}, {state.city}, {countries[state.country] || 'Inconnu'}
              </p>
              <p>
                <FontAwesomeIcon icon={faPaperPlane} className='mr-2'/>
                <a href={`mailto:${state.notifyMail}`}>{state.notifyMail}</a>
              </p>
              <p>
                <FontAwesomeIcon icon={faPhone} className='mr-2'/>
                <a href={`tel:${state.phone}`}>{state.phone}</a>
              </p>
              <p>
                <FontAwesomeIcon icon={faClock} className='mr-2'/>
                {state.opening_hours}
              </p>
            </div>
          </div>
          <div>
            <Button onClick={goEdit} variant='outline' className="w-48 mb-2 flex items-center justify-center">
              <FontAwesomeIcon icon={faPencil}/>Modifier les infos.
            </Button>
            <div className="flex flex-col items-center justify-center gap-2 w-48">
              <Button
                type="button"
                variant="outline"
                className="w-full flex items-center justify-center"
                onClick={() => fileInputRef.current?.click()}
              >
                <FontAwesomeIcon icon={faImage}/>
                Mettre à jour le logo
              </Button>
              <Input
                id="picture"
                type="file"
                style={{display:'none'}}
                accept="image/*"
                onChange={onFileChange}
                ref={fileInputRef}
              />
            </div>
            <div className="mt-2 w-48 flex items-center justify-center">
              <OfferSelect place={place} />
            </div>
          </div>
        </div>
        
      </>
    )
  }

  return (
    <>
      <form
        className="flex flex-col gap-4 w-full max-w-lg mx-auto mb-10 p-4 border rounded-md bg-white shadow-md"
        onSubmit={save}
      >
        <div>
          <Label htmlFor="name">Nom</Label>
          <Input id="name" name="name" type="text" value={state.name} onChange={onChange} />
        </div>
        <div>
          <Label htmlFor="address">Adresse</Label>
          <Input id="address" name="address" type="text" value={state.address} onChange={onChange} />
        </div>
        <div>
          <Label htmlFor="address2">Complément d'adresse</Label>
          <Input id="address2" name="address2" type="text" value={state.address2} onChange={onChange} />
        </div>
        <div className="flex gap-2">
          <div className="flex-1">
            <Label htmlFor="zip">Code postal</Label>
            <Input id="zip" name="zip" type="text" value={state.zip} onChange={onChange} />
          </div>
          <div className="flex-1">
            <Label htmlFor="city">Ville</Label>
            <Input id="city" name="city" type="text" value={state.city} onChange={onChange} />
          </div>
        </div>
        <div>
          <Label htmlFor="country">Pays</Label>
          <Select id="country" name="country" type="text" value={state.country} onChange={onChange}>
            {Object.entries(countries).map(([k, v]) =>
              <option key={k} value={k}>{v}</option>
            )}
          </Select>
        </div>
        <div>
          <Label htmlFor="notifyMail">Email de notification</Label>
          <Input id="notifyMail" name="notifyMail" type="text" value={state.notifyMail} onChange={onChange} />
        </div>
        <div>
          <Label htmlFor="phone">Téléphone du club</Label>
          <Input id="phone" name="phone" type="text" value={state.phone} onChange={onChange} placeholder='' />
        </div>
        <div>
          <Label htmlFor="opening_hours">Horaires d'ouverture</Label>
          <Input id="opening_hours" name="opening_hours" type="text" value={state.opening_hours} onChange={onChange} placeholder='Du lundi au vendredi de 06h à 22h, le week-end de 08h à 22h' />
        </div>
        <div className="flex justify-center mt-4">
          <Button type="submit" variant="default">Enregistrer les modifications</Button>
        </div>
      </form>
    </>
  )
}


function OfferSelect({place}){
  const offers = useOfferList({velId: place.r2vel});
  const { mutate } = usePlacePatch({velId: place.r2vel, placeId: place.msdsId});

  const onChange = e => {
    if( e.target.value === '') {
      mutate({offer_url: null})
    } else {
      mutate({offer_url: e.target.value})
    }
  };

  if( !offers.data )
    return null;

  return (
      <Select className="border-input" value={place.offer_url || ''} onChange={onChange}>
        <option value=''>Bannière par défaut</option>
        {offers.data.map( o => <option key={o.id} value={o.url}>{o.title || `Bannière #${o.id}`}</option>)}
      </Select>
  )
}